export default "__VITE_ASSET__CghDMZgF__"